import { render } from "./ServicePerformanceReport.vue?vue&type=template&id=2bdc44c4&scoped=true"
import script from "./ServicePerformanceReport.vue?vue&type=script&lang=js"
export * from "./ServicePerformanceReport.vue?vue&type=script&lang=js"

import "./ServicePerformanceReport.vue?vue&type=style&index=0&id=2bdc44c4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdc44c4"]])

export default __exports__